/**
 * ของสวมใส่แบบมีตัวตน (PLAN ขั้นที่ 3.2)
 *
 * **ของธรรมดายังนับเป็นจำนวนต่อ id ในกระเป๋าเหมือนเดิม** (`items`)
 * แต่ของที่ "ไม่ธรรมดา" แล้ว — ตีบวกไปแล้วหรือมีการ์ด — แยกเป็นชิ้นของตัวเองมี uid
 * เพราะถ้าถอดแล้วนับรวมเป็นจำนวน ระดับตีบวกกับการ์ดจะไม่มีที่อยู่ (เดิมหายไปตอนถอด)
 *
 * เลือกแบบผสมแทน "ทุกชิ้นเป็น instance" เพราะร้าน ดรอป เทรด ร้านผู้เล่น และคลัง
 * ยังใช้ของแบบนับจำนวนได้ต่อทั้งหมด ไม่ต้องย้ายข้อมูลเก่าเลย
 * ของสวมอยู่ยังเก็บแยกช่องเหมือนเดิม (`equipped` `refines` `cards`) ผู้เล่นคนอื่นจึงเห็นเหมือนเดิม
 *
 * ชิ้นในกระเป๋าเก็บเป็นสตริงย่อใน `MapSchema<string>` (uid → `itemId|refine|การ์ดคั่น,`)
 * ช่องที่สี่ = ออปชันสุ่ม (ขั้น 3.6 `id:ค่า;…`) ไม่มีก็ไม่ต่อท้าย ข้อมูลเก่าจึงอ่านได้เหมือนเดิม
 *
 * pure function ทั้งหมด
 */
import { mapEntries } from "./equip.js";
import { parseCards } from "./cards.js";
import { MAX_REFINE_LEVEL } from "./refine.js";
import { encodeOptions, parseOptions } from "./options.js";
/** แปลงเป็นสตริงย่อสำหรับ sync */
export function encodeGear(g) {
    const opts = g.options?.length ? `|${encodeOptions(g.options)}` : "";
    return `${g.itemId}|${g.refine}|${g.cards.join(",")}${opts}`;
}
/** อ่านสตริงย่อ ค่าเพี้ยนกลายเป็นค่าปลอดภัย (ตีบวกถูกหนีบ 0..เพดาน) */
export function parseGear(raw) {
    const [itemId = "", refine = "0", cards = "", opts = ""] = (raw ?? "").split("|");
    const lv = Math.trunc(Number(refine));
    const options = parseOptions(opts);
    return {
        itemId,
        refine: Number.isFinite(lv) ? Math.max(0, Math.min(MAX_REFINE_LEVEL, lv)) : 0,
        cards: parseCards(cards),
        ...(options.length ? { options } : {}),
    };
}
/** ชิ้นนี้ต้องแยกเป็นชิ้นมีตัวตนไหม (ไม่ใช่ = กลับไปนับรวมจำนวนในกระเป๋าได้) */
export function isSpecialGear(g) {
    return g.refine > 0 || g.cards.length > 0 || (g.options?.length ?? 0) > 0;
}
/** น้ำหนักของชิ้นมีตัวตนทั้งหมด (รวมกับ `bagWeight` ของของนับจำนวน) */
export function gearWeight(gear, items) {
    let w = 0;
    for (const [, raw] of mapEntries(gear))
        w += items[parseGear(raw).itemId]?.weight ?? 0;
    return w;
}
/** ชื่อแสดงผล เช่น "+7 ดาบเหล็กลายป่า [2]" (ตัวเลขในวงเล็บ = จำนวนการ์ด) */
export function gearLabel(g, items) {
    const name = items[g.itemId]?.name ?? g.itemId;
    return `${g.refine > 0 ? `+${g.refine} ` : ""}${name}${g.cards.length ? ` [${g.cards.length}]` : ""}`;
}
//# sourceMappingURL=gear.js.map